import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface TokenListVisualNumberCellProps
  extends CellContext<GatewayTokenModel, GatewayTokenModel['visualNumber']> {}

export const TokenListVisualNumberCell = (
  props: TokenListVisualNumberCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(generatePath(APP_PATH.TOKEN.DETAILS, { id: row.original.id }))
      }>
      <Text>{getValue() ?? '-'}</Text>
    </Link>
  );
};
